import * as types from '../mutation-types'

// initial state
const state = {
  qrcodePopup: {
    isShow: false,
    qrCodeSrc: '',
    platformType: 0
  },
  guideEvaluationPopup: {
    isShow: false,
    RewardFreeCard: 0
  }
}

// getters
const getters = {
  getQrcodePopup: (state) => state.qrcodePopup,
  getGuideEvaluationPopup: (state) => state.guideEvaluationPopup
}

// mutations
const mutations = {
  [types.SET_QRCODE_POPUP](state, qrcodePopup) {
    state.qrcodePopup = qrcodePopup
  },
  [types.SET_GUIDE_EVALUATION_POPUP](state, guideEvaluationPopup) {
    state.guideEvaluationPopup = guideEvaluationPopup
  }
}
// actions
const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}
